export default {"src":"/_next/static/media/linkedin.264d050d.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};